<template>
  <el-upload
    ref="upload"
    action="#"
    :http-request="submitUpload"
    :on-change="handleChange"
    :on-remove="handleRemove"
    :before-remove="beforeRemove"
    multiple
    :limit="1"
    :on-exceed="handleExceed"
    :file-list="fileList"
    v-loading="loading"
  >
    <el-button size="small" type="primary" plain>点击上传</el-button>
  </el-upload>
</template>

<script>
export default {
  name: "ImgUpload",
  data() {
    return {
      fileList: [],
      url: "",
      loading: false
    };
  },
  methods: {
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    handleRemove() {
      this.url = "";
      this.$emit("onUpload");
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    submitUpload() {
      this.loading = true;
      let formData = new FormData();
      this.fileList.forEach(item => {
        formData.append("file", item.raw);
      });
      this.axios.post("/game/imgUpload", formData).then(resp => {
        if (resp) {
          this.url = resp.data;
          this.$emit("onUpload");
          this.loading = false;
          this.$message.warning("上传成功");
        }
      });
    }
  }
};
</script>

<style scoped></style>
